export default __webpack_public_path__ + "static/media/kitten.5dd33e0b.png";